export default __webpack_public_path__ + "assets/img/3l5dtmx.png";